<footer class="footer">

	<div class="shell shell--size-8">
		<div class="footer__inner">
			<div class="footer__content">
				<a (click)="loginCheck()" class="btn btn--transparent hidden-xs" style="margin-right: 2%">
					<span class="white">Client Portal</span>
				</a>
				<span *ngIf="!mobile">
					<app-contactus-component></app-contactus-component>
				</span>



				<nav class="footer__nav">
					<ul>
						<li>
							<a [routerLink]="['/']">Home</a>
						</li>

						<li>
							<a onClick="document.location='/#about';">About</a>
						</li>
						<!-- Home / About / Academy / Newsletter / Brochure -->
						<li>
							<!-- <a onClick="document.location='/#etoroLoc';">eToro</a> -->
							<a [routerLink]="['/academy']">Academy</a>
						</li>

						<li>
							<!-- <a onClick="document.location='/#backtesting';">Backtesting</a> -->
							<a onClick="document.location='/#performance';">Performance</a>
						</li>

						<li>
							<a onClick="document.location='/#brochure';">Brochure</a>
						</li>

					</ul>
				</nav><!-- /.footer__nav -->
				<!-- <a [routerLink]="['/privacy']">Privacy</a>
				<a [routerLink]="['/cookies']">Cookies</a>
				<a [routerLink]="['/disclaimer']">Disclaimer</a> -->
				<span *ngIf="mobile">
					<div class="row" style="margin-bottom: 10%">
						<a href="https://play.google.com/store/apps/details?id=com.thecosmos.app" target="_blank">
							<img src="../../../assets/img/downloadAndroid.png" style="height:46px; width: 137.61px"/>
						</a>
					</div>
					<div class="row">
						<a href="https://apps.apple.com/us/app/cosmic-algorithm/id6741114766" target="_blank">
							<img src="../../../assets/img/downloadIOS.svg" style="height:46px; width: 137.61px"/>
						</a>
					</div>
				</span>

			</div><!-- /.footer__content -->
			<div class="form">
				<ngb-toast *ngIf="show" [autohide]="true" (hidden)="close()" class="successParent" id="succ">
					<div class="successNot">
						{{subText}}
					</div>
				</ngb-toast>
				<ngb-toast *ngIf="fail" [autohide]="true" (hidden)="close()" class="failParent" id="fail">
					<div class="failNot">
						{{subText}}
					</div>
				</ngb-toast>
				<form action="?" method="post">
					<div class="form__head">
						<h5>Subscribe to our Newsletter</h5>
					</div><!-- /.form__head -->

					<div class="form__body">
						<label for="email" class="form__label hidden"></label>

						<div class="form__controls">
							<input type="email" name="email" id="email" class="form-control" class="field"
								placeholder="Email Address" (input)="subscribeEmail=$event.target.value">
						</div><!-- /.form__controls -->

						<div class="form__actions">
							<input type="submit" value="Subscribe" class="form__btn" (click)="submitFoot()">
						</div><!-- /.form__actions -->
					</div><!-- /.form__body -->

					<div id="message"></div>

				</form>
				<a style="text-decoration: none;
				font-size: 1.6rem;
				font-weight: 500;
				color: #E9E9E9;
				transition: color 0.4s;" [routerLink]="['/newsletter']">View our current newsletter&nbsp;<i class="fa-solid fa-arrow-up-right-from-square"></i></a>
			</div><!-- /.form -->
			<div class="btnPos" *ngIf="mobile">
				<app-contactus-component></app-contactus-component>
			</div>
			<div class="btnPos" style="text-align: center;
			display: flex;
			flex-direction: column;
			justify-content: flex-end;" *ngIf="!mobile">
				<div class="row" style="margin-bottom: 10%">
					<a href="https://play.google.com/store/apps/details?id=com.thecosmos.app" target="_blank">
						<img src="../../../assets/img/downloadAndroid.png" style="height:52px; width: 155.56px"/>
					</a>
				</div>
				<div class="row">
					<a href="https://apps.apple.com/us/app/cosmic-algorithm/id6741114766" target="_blank">
						<img src="../../../assets/img/downloadIOS.svg" style="height:52px; width: 155.56px"/>
					</a>
				</div>
			</div>

		</div><!-- /.footer__inner -->
	</div><!-- /.shell -->

</footer><!-- /.footer -->
<div class="bar">
	<div class="shell" style="text-align: center;">
		<div class="bar__inner">
			<div class="row">
				<div class="col" class="posRel">
					<a href="#" (click)="changePrivacySettings($event)" style="font-size: x-small">Change privacy settings</a>
				</div>
				<!-- <div class="col" style="position: absolute;" *ngIf="!mobile">
				</div> -->
			</div>
			<br/>
			<div class="row">
				<div class="col" class="posRel">
					<img src="assets/img/temp/bar-img.jpg" alt="footer image">

					<p>&copy; {{year}} Cosmic Algorithm Ltd.</p>
				</div>
				<!-- <div class="col" style="position: absolute;" *ngIf="!mobile">
				</div> -->
			</div>


		</div><!-- /.bar__inner -->
	</div><!-- /.shell -->
</div><!-- /.bar -->

<script src="assets/vendor/jquery-3.6.0.min.js"></script>
<script src="assets/js/bundle.js"></script>